import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FlowType } from "../constants";
import { flowTypeSelector } from "../services/selectors";

const Authenticated = ({
  children,
  FallbackComponent,
  LoaderComponent
}) => {
  const flowType = useSelector(flowTypeSelector);

  switch (flowType) {
    case FlowType.INDETERMINATE:
      return /*#__PURE__*/React.createElement(LoaderComponent, null);

    case FlowType.ANONYMOUS:
      return /*#__PURE__*/React.createElement(FallbackComponent, null);

    case FlowType.AUTHENTICATED:
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);

    default:
      return null;
  }
};

Authenticated.propTypes = {
  children: PropTypes.node.isRequired,
  FallbackComponent: PropTypes.elementType,
  LoaderComponent: PropTypes.elementType
};

const Empty = () => null;

Authenticated.defaultProps = {
  FallbackComponent: Empty,
  LoaderComponent: Empty
};
export default Authenticated;